// 一期可用的英雄名单（其余英雄在 P2 之后逐步启用）
export const PHASE1_HEROES = [
  "法师",
  "战士",
  "道士",
  "弓箭手",
  "骑士兵团",
  "巨剑骑士",
  "治愈天使",
  "圣殿骑士",
] as const;

export type Phase1HeroName = (typeof PHASE1_HEROES)[number];

export function isPhase1Hero(name: string): name is Phase1HeroName {
  return (PHASE1_HEROES as readonly string[]).includes(name);
}
